import React, { ChangeEvent, memo } from 'react';
import { useTranslation } from 'i18n';
import { makeEntitiesLoader } from 'hooks/makeSimpleLoader';

import { EventTargetAgesActions } from 'store/actions';
import { EventTargetAgesSelectors } from 'store/selectors';

import { clearValueParser, idValueFormatter, nameValueParser, titleLabelFormatter } from './utils';
import FilterSelectHandler from './FilterSelectHandler';

const ALL_AGE_SLUG = 'all-ages';

export interface IEventTargetAgesFilterProps {
  disabled?: boolean;
}

const useEventTargetAgesState = makeEntitiesLoader(
  EventTargetAgesActions.getEventTargetAges,
  EventTargetAgesSelectors.eventTargetAgesState,
);

const EventTargetAgesFilter: React.FC<React.PropsWithChildren<IEventTargetAgesFilterProps>> = (props) => {
  const { disabled } = props;

  const [t] = useTranslation();
  const state = useEventTargetAgesState();

  const valueTransformer = ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
    const allAge = state.entities.find((entity) => entity.slug === ALL_AGE_SLUG);
    const allAgeId = String(allAge?.id);

    if (Array.isArray(value)) {
      if (value.indexOf(allAgeId) > -1 && value[0] === allAgeId && value.length > 1) {
        return { [name]: (value as unknown as string[]).filter((item) => item !== allAgeId) };
      }

      if (value.indexOf(allAgeId) > -1) {
        return { [name]: allAgeId };
      }
    }

    return { [name]: value };
  };

  return (
    <FilterSelectHandler
      multiple
      name="target_age"
      placeholder={t<string>('common:filter.targetAge')}
      disabled={disabled || state.isFetching}
      items={state.entities.sort((a: any, b: any) => a.order - b.order)}
      labelFormatter={titleLabelFormatter}
      valueFormatter={idValueFormatter}
      valueTransformer={valueTransformer}
      valueParser={nameValueParser}
      clearValueParser={clearValueParser}
    />
  );
};

export default memo(EventTargetAgesFilter);
